import {useEffect, useState} from 'react';

export const SEARCH_MIN_LENGTH = 3;
const SEARCH_DEBOUNCE_MS = 400;

export const useDebouncedSearch = (search: string) => {
  const [debouncedSearch, setDebouncedSearch] = useState('');

  useEffect(() => {
    const trimmed = search.trim();
    const next = trimmed.length >= SEARCH_MIN_LENGTH ? trimmed : '';
    const timeout = setTimeout(
      () => setDebouncedSearch(next),
      SEARCH_DEBOUNCE_MS,
    );
    return () => clearTimeout(timeout);
  }, [search]);

  return debouncedSearch;
};
